import { Injectable } from '@angular/core';
import * as fileSaver from 'file-saver';

import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';

import { Observable } from 'rxjs';
import { api, utils } from "@bayclubs/utils"
import { camps } from '../../models/models.generated';

@Injectable({
    providedIn: 'root'
})
export class ReportsApiService {

    constructor(private http: ApiHttpClient) { }

    public searchForEnrollmentReport(request: camps.EnrollmentReportRequest, useV2: boolean = false): Observable<api.OperationResultValue<camps.EnrollmentReportInfoModel>> {
        const url = useV2 ? "report/enrollment/search/v2" : "report/enrollment/search";
        return this.http.post<api.OperationResultValue<camps.EnrollmentReportInfoModel>>(url, request, false);
    }

    public getEnrollmentReport(request: camps.EnrollmentReportRequest, useV2: boolean = false) {
        this.http.postFileRequest(useV2 ? 'report/enrollment/v2' : 'report/enrollment', request)
            .subscribe((responseSuccess: any) => {

                var blob = new Blob([responseSuccess], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, this.buildFileName(request.dateFrom,request.dateTo,useV2 ? 'EnrollmentReportV2' : 'EnrollmentReport'));

            }, () => {
               // this.alert.showError("File not found.")
            });
    }


    public searchForCapacityReport(request: camps.CapacityReportRequest): Observable<api.OperationPagedResult<camps.CapacityReportInfoItem>> {
        return this.http.post<api.OperationPagedResult<camps.CapacityReportInfoItem>>("report/capacity/search", request, false);
    }

    public getCapacityReport(request: camps.CapacityReportRequest) {
        this.http.postFileRequest('report/capacity',request)
            .subscribe((responseSuccess: any) => {

                var blob = new Blob([responseSuccess], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, this.buildFileName(request.dateFrom,request.dateTo,'CapacityReport'));

            }, () => {
               // this.alert.showError("File not found.")
            });
    }

    public searchForTransactionReport(request: camps.TransactionReportRequest): Observable<api.OperationPagedResult<camps.TransactionReportInfoItem>> {
        return this.http.post<api.OperationPagedResult<camps.TransactionReportInfoItem>>("report/transaction/search", request, false);
    }

    public getTransactionReport(request: camps.TransactionReportRequest) {
        this.http.postFileRequest('report/transaction',request)
            .subscribe((responseSuccess: any) => {

                var blob = new Blob([responseSuccess], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, this.buildFileName(request.dateFrom,request.dateTo,'TransactionReport'));

            }, () => {
               // this.alert.showError("File not found.")
            });
    }

    private buildFileName(dateFrom: utils.BcDate, dateTo: utils.BcDate, filePrefix : string){
        if(dateFrom && dateTo){
            return `${filePrefix}_${dateFrom.value}_${dateTo.value}.xlsx`;
        }

        if(dateFrom){
            return `${filePrefix}_from_${dateFrom.value}.xlsx`;
        }

        if(dateTo){
            return `${filePrefix}_to_${dateTo.value}.xlsx`;
        }

        return `${filePrefix}.xlsx`;
    }
}
